<template>
	<SOSlotBase :bg-white="true" :loading="pageSetting.loading">
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Nota Transaksi Self Service'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div v-if="detail.data.detail_transaksi.status_hapus === 1">
				<div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center border-bottom">
					<img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
					<div class="d-block">
						<div class="f-regular f-14 f-c-black">
							Nota ini butuh konfirmasi penghapusan
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							Lakukan konfirmasi di halaman pembatalan
						</div>
					</div>
				</div>
				<div class="bg-yellow p-x-20 p-y-8 d-flex flex-column justify-content-start border-bottom">
					<SOTextEllipsis
						:line-numbers="3"
						:text-label="'Keterangan:'"
						:text-content="detail.data.detail_transaksi.keterangan_permintaan_hapus"
					/>
				</div>
				<div class="bg-yellow p-x-20 p-y-8 f-regular f-12 f-c-midgrey border-bottom">
					Lakukan konfirmasi melalui tombol di bawah.
				</div>
			</div>

			<div class="p-x-20 p-y-20">
				<SOTransaksiSnapcleanDetailTipe
					:snap-transaksi="detail.data.detail_transaksi"
				/>
			</div>
			<div class="separator"></div>

			<div class="p-x-20 p-y-20">
				<SOTransaksiInfo
					:transaksi="detail.data"
					:is-self-service="detail.data.detail_transaksi.jenis === 1"
				/>
			</div>
			<div class="separator"></div>


			<div class="p-x-16"
			     :class="{'p-y-20': detail.data.detail_transaksi.status_hapus !== 1, 'p-d-72 p-t-20': detail.data.detail_transaksi.status_hapus === 1}"
			     style="background: linear-gradient(180deg, rgba(242, 245, 247, 0) 0%, #F2F5F7 100%);"
			>
				<SOTransaksiDetailTagihan
					:layanan-snapclean="true"
					:snapclean-self-service="true"
					:snapclean-drop-off="true"
					:transaksi="detail.data"
					:is-self-service="detail.data.detail_transaksi.jenis === 1"
				/>
			</div>

<!--			<div class="p-x-20 p-y-12 f-regular f-12 f-c-midgrey" v-if="detail.data.detail_transaksi.jenis === 1">-->
<!--				Transaksi Self Service tidak dapat di hapus / refund.-->
<!--			</div>-->
			<div class="p-x-20 p-y-20" v-if="detail.data.detail_transaksi.hapus === 0 && isRefundable && validateAccess('selfService.delete')">
				<SOButton
					:text="'Hapus Transaksi'"
					:outline-danger="true"
					:full="true"
					@action="() => { pageSetting.modal.deleteTransaksi = true }"
				/>
			</div>

			<div
				v-if="detail.data.detail_transaksi.status_hapus === 1 && validateAccess('deleteSelfService.confirm')"
				class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
				style="position: fixed; bottom: 64px"
			>
				<div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
					<SOButton
						:outline="true"
						:full="true"
						:text="'Tolak'"
						@action="tolakPenghapusan"
					/>
				</div>
				<div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
					<SOButton
						:primary="true"
						:full="true"
						:text="'Setujui'"
						@action="setujuiPenghapusan"
					/>
				</div>
			</div>
		</template>

		<template v-slot:modal>
			<TransaksiSnapcleanModalHapus
				v-if="pageSetting.modal.deleteTransaksi"
				:transaksi="detail.data"
				@close="() => { pageSetting.modal.deleteTransaksi = false }"
			/>
			<SOTerimaModal
				v-if="pageSetting.modal.penghapusan.setujui"
				:use-route-push="false"
				@close="() => { pageSetting.modal.penghapusan.setujui = false }"
			/>
			<SOTolakModal
				v-if="pageSetting.modal.penghapusan.tolak"
				:use-route-push="false"
				@close="() => { pageSetting.modal.penghapusan.tolak = false }"
			/>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

import SOTransaksiSnapcleanDetailTipe
	from "@/so-components/modules/transaksi/snapclean/detail/SOTransaksiSnapcleanDetailTipe";
import SOTransaksiInfo from "@/so-components/modules/transaksi/SOTransaksiInfo";
import SOTransaksiDetailTagihan from "@/so-components/modules/transaksi/reguler/detail/SOTransaksiDetailTagihan";

import TransaksiSnapcleanModalHapus from "./modal/TransaksiSnapcleanModalHapus";
import SOTolakModal from "./../../../penghapusan-transaksi/snapclean/components/SOTolakModal";
import SOTerimaModal from "./../../../penghapusan-transaksi/snapclean/components/SOTerimaModal";

import SOTextEllipsis from "@/so-components/global/ui/SOTextEllipsis";

export default {
	name: "TransaksiSnapcleanDetail",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,
		SOButton,

		SOTransaksiSnapcleanDetailTipe,
		SOTransaksiInfo,
		SOTransaksiDetailTagihan,

		TransaksiSnapcleanModalHapus,
		SOTolakModal,
		SOTerimaModal,

		SOTextEllipsis,
	},
	computed: {
		...mapGetters("transaksiSnapcleanModule", {
			detail: "getDetailTransaksi",
		}),
		isRefundable() {
			let {query: {refundable}} = this.$route;
			return refundable !== undefined ? refundable : true;
		}
	},
	data() {
		return {
			pageSetting: {
				loading: true,
				modal: {
					deleteTransaksi: false,
					penghapusan: {
						setujui: false,
						tolak: false,
					}
				}
			}
		}
	},
	mounted() {
		this.idsnapTransaksi = this.$route.params.idsnap_transaksi
		this.getDetailTransaksi()
	},
	methods: {
		back() {
			this.$router.back()
		},
		async getDetailTransaksi() {
			const res = await this.$store.dispatch("transaksiSnapcleanModule/fetchDetailTransaksi", this.idsnapTransaksi)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
			}
		},
		setujuiPenghapusan() {
			this.pageSetting.modal.penghapusan.setujui = true
		},
		tolakPenghapusan() {
			this.pageSetting.modal.penghapusan.tolak = true
		}
	},
	beforeDestroy() {
		this.$store.commit("transaksiSnapcleanModule/resetDetailTransaksi")
	}
}
</script>